// extracted by mini-css-extract-plugin
module.exports = {"token_icon":"TokenIcon_token_icon__3jmIQ","token_logo_wrapper":"TokenIcon_token_logo_wrapper__2iFOE"};